function addGiftBoxOptionCartItem(cartData, lineIndex, variantId, quantity, properties = {}) {
  cartData.append(`items[${lineIndex}][id]`, variantId);
  cartData.append(`items[${lineIndex}][quantity]`, quantity);

  Object.entries(properties).forEach(([key, value]) => {
    cartData.append(`items[${lineIndex}][properties][${key}]`, value);
  });
}

function getGiftBoxOptionProperties(formData) {
  const properties = {};

  formData.forEach((value, key) => {
    const propertyName = key.match(/^properties\[(.+)\]$/)?.[1];
    if (propertyName) properties[propertyName] = value;
  });

  return properties;
}

function createGiftBoxOptionsCartData(formData, giftBox) {
  const cartData = new FormData();
  const productVariantId = formData.get('id');
  const productQuantity = formData.get('quantity') || 1;
  let lineIndex = 0;

  addGiftBoxOptionCartItem(cartData, lineIndex, productVariantId, productQuantity, {
    ...getGiftBoxOptionProperties(formData),
    _gift_box_options_selected: 'true',
    _gift_box_options_group_id: giftBox.groupId,
  });
  lineIndex += 1;

  if (formData.get('aplusproducts')) {
    formData.get('aplusproducts').split(',').forEach((product) => {
      const [variantId, , quantity] = product.split('-');
      if (!variantId || !quantity) return;
      addGiftBoxOptionCartItem(cartData, lineIndex, variantId, quantity);
      lineIndex += 1;
    });
  }

  if (formData.get('freegiftproduct')) {
    addGiftBoxOptionCartItem(cartData, lineIndex, formData.get('freegiftproduct'), productQuantity, {
      _gift_with_product: formData.get('giftwithproduct'),
    });
    lineIndex += 1;
  }

  const giftBoxProperties = {
    'Gift box for': giftBox.productTitle,
    'Gift box': giftBox.variantTitle,
    _gift_box_options_for_variant_id: productVariantId,
    _gift_box_options_group_id: giftBox.groupId,
  };
  if (giftBox.message) giftBoxProperties['Gift message'] = giftBox.message;

  addGiftBoxOptionCartItem(cartData, lineIndex, giftBox.variantId, giftBox.quantity, giftBoxProperties);

  if (formData.get('sections')) cartData.append('sections', formData.get('sections'));
  if (formData.get('sections_url')) cartData.append('sections_url', formData.get('sections_url'));
  return cartData;
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.quickAddModal = this.closest('quick-add-modal');
        this.isQuickAdd = this.quickAddModal !== null;
        this.submitButton = this.querySelector('[type="submit"]');
        this.viewFullDetailsButton = this.querySelector('.btn-product-full-details');
        // if(this.submitButton.getAttribute('data-personalized') === 'true'){
        //   this.form.addEventListener('submit', this.onPersonalizedSubmitHandler.bind(this));
        // }else{
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //}
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.wrapper = this.closest('.product');
        this.giftBoxOptionsSelection = null;
        this.addEventListener('giftboxoptions:confirm', (event) => {
          this.giftBoxOptionsSelection = event.detail;
          this.form.requestSubmit();
        });
      }

      // onPersonalizedSubmitHandler(evt) {
      //   evt.preventDefault();
      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];
      //   const formData = new FormData()
      //   formData.set('id',this.submitButton.getAttribute('data-personalize-variant-id'))
      //   formData.set('product-id',this.submitButton.getAttribute('data-personalize-product-id'))
      //   config.body = formData;
      //   fetch(`${routes.cart_add_url}`, config)
      //   .then((response) => response.json())
      //   .then((response) => {
      //     console.log(response)
      //   })
      //   .catch((e) => {
      //     console.error(e);
      //   })
      //   .finally(() => {
      //     this.onSubmitHandler(evt)
      //   });
      // }

      onSubmitHandler(evt) {
        const isStickyAddToCart = this.submitButton.dataset.stickyAddToCart !== undefined;

        evt.preventDefault();

        // on mobile, ensure options panel is visible
        let mobOptions = document.querySelector('[data-moboptions]');
        if (mobOptions) {

          if (window.innerWidth < 768 && mobOptions.dataset.moboptions !== 'true' && mobOptions.querySelectorAll('#option-nav-mob a').length) {

            // adjust panel height
            const openOptionsEvent = new Event("openoptions");
            window.dispatchEvent(openOptionsEvent);

            // adjust panel height
            const panelEvent = new Event("panelheight");
            window.dispatchEvent(panelEvent);


            return false;
          }

        }

        if (this.submitButton.getAttribute('data-personalized') === 'true') {
          const mainProductSection = this.closest('.section-main-product-js') ?? this.closest('.quick-add-modal');
          if (!mainProductSection) return

          if (mainProductSection.querySelector("#monogram").value === "") {
            console.log("iN error");
            this.hideErrors = false;
            this.handleErrorMessage("Please Enter Monogram Text");
            return;
          }
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(isStickyAddToCart
          ? this.closest('.product').querySelector('[data-main-product-form] form')
          : this.form);

        if (this.cart) {

          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );

          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        console.log("aplus", formData.get("aplusproducts"))

        const giftBoxOptions = this.giftBoxOptionsSelection;
        let itemsInCart = 0
        if (giftBoxOptions) {
          config.body = createGiftBoxOptionsCartData(formData, giftBoxOptions);
          this.giftBoxOptionsSelection = null;
        } else if (formData.get("aplusproducts")) {
          let newFormData = new FormData();
          newFormData.append("items[0][id]", formData.get("id"))
          itemsInCart++
          newFormData.append("sections", formData.get("sections"))
          newFormData.append("sections_url", formData.get("sections_url"))
          let aPlusProducts = formData.get("aplusproducts")
          let aplus_array = aPlusProducts.split(",")
          aplus_array.map((ap, i) => {
            let t = ap.split("-")
            if (t.length > 1) {
              itemsInCart++
              newFormData.append(`items[${i + 1}][id]`, t[0])
              newFormData.append(`items[${i + 1}]][quantity]`, t[2])
            }
          })
          config.body = newFormData;
        } else {
          config.body = formData;
        }
        
        console.log("freegiftproduct",formData.get("freegiftproduct"))
        const giftInput = this.wrapper?.querySelector('[data-gift-product-input]');
        const giftForm = this.wrapper?.querySelector('[data-gift-box-form]');
        if (!giftBoxOptions && giftInput && giftForm && giftInput.checked) {
          config.body.append(`items[${itemsInCart}][id]`, giftInput.dataset.giftVariant);
          config.body.append(`items[${itemsInCart}][quantity]`, 1);
          config.body.append(`items[${itemsInCart}][properties][_gift_box_for_product]`, giftInput.dataset.giftForProduct);
          config.body.append(`items[${itemsInCart}][properties][_gift_box_message]`, giftForm.querySelector('[name=message]').value);
          config.body.append(`items[${itemsInCart}][properties][_gift_box_recipient]`, giftForm.querySelector('[name=recipient]').value);
          config.body.append(`items[${itemsInCart}][properties][_gift_box_sender]`, giftForm.querySelector('[name=sender]').value);
        }

        if(!giftBoxOptions && formData.get("freegiftproduct")){
          config.body.append(`items[${itemsInCart}][id]`, formData.get("freegiftproduct"));
          config.body.append(`items[${itemsInCart}][quantity]`, formData.get("quantity"));
          config.body.append(`items[${itemsInCart}][properties][_gift_with_product]`, formData.get("giftwithproduct"));
          itemsInCart++
        }

        itemsInCart = 0

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelectorAll('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', 'false');
              this.submitButton.querySelector('span').classList.add('hidden');

              soldOutMessage.forEach((obj) => {
                obj.classList.remove('hidden');
              })
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            if (this.submitButton.getAttribute('data-personalized') === 'true') {
              showHideDrawer(this);
              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
              const formData1 = new FormData()
              formData1.set('id', this.submitButton.getAttribute('data-personalize-variant-id'))
              formData1.set('product-id', this.submitButton.getAttribute('data-personalize-product-id'))
              if (this.cart) {
                formData1.append(
                  'sections',
                  this.cart.getSectionsToRender().map((section) => section.id)
                );
                formData1.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
              }
              config.body = formData1;
              fetch(`${routes.cart_add_url}`, config)
                .then((response1) => response1.json())
                .then((response1) => {

                if (this.isQuickAdd) {
                  this.quickAddModal.handleQuickAddThankYouModal(response1);
                  this.cart.renderContents(response1, true);
                } else {
                  this.cart.renderContents(response1);
                }
                  this.clearSelection();
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {

                });
            } else {

              if (this.isQuickAdd) {
                this.quickAddModal.handleQuickAddThankYouModal(response);
                this.cart.renderContents(response, true);
              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            App.overflowFloatedStyle();
          });
      }

      clearSelection() {
        document.querySelector('#monogram').value = "";
        document.querySelector("#personalization_text_input").value = "";
        document.querySelector(".personalization_image .personalization_text .mono-text").innerHTML = "";
        document.querySelectorAll(".personalize-font-selector")[0].click()
        document.querySelectorAll(".personalize-color-selector")[0].click()
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          if (typeof errorMessage === 'object' && !Array.isArray(errorMessage) && errorMessage !== null) {
            var errorMsgs = []
            Object.keys(errorMessage).forEach((key) => {
              if (Array.isArray(errorMessage[key])) {
                errorMsgs = [...errorMsgs, ...errorMessage[key]]
              } else {
                errorMsgs.push(errorMessage[key])
              }
            })

            this.errorMessage.innerHTML = '<pre style="font-family:inherit;">' + errorMsgs.join("\n") + '<pre>';

          } else {
            this.errorMessage.textContent = errorMessage;
          }

        }
      }
    }
  );
}
